import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Button, TextField, Typography } from '@material-ui/core'

type MemberInformationDialogProps = {
  open: boolean
  onClose: () => void,
  removeMemberClicked: () => void
}

const MemberInformationDialogContent = styled(DialogContent)`
  width: 30vw;
`
const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`
const UserNameTypography = styled(Typography)`
  margin-bottom: 28px;
`
const UnderstandingNameTextField = styled(TextField)`
  width: 90%;
  margin-bottom: 32px;
`

const MemberInformationDialog: React.FC<MemberInformationDialogProps> = ({open, onClose, removeMemberClicked}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle>メンバー情報</DialogTitle>
      <MemberInformationDialogContent style={{overflow: 'hidden'}}>
        <LabelTypography variant="caption">メールアドレス</LabelTypography>
        <Typography variant="h6" gutterBottom>user1@sample.com</Typography>
        <LabelTypography variant="caption">ユーザ名</LabelTypography>
        <UserNameTypography variant="h6">ぷよぷよ</UserNameTypography>
          <UnderstandingNameTextField label="あなたにとっての認識名" variant="outlined" defaultValue="てるちゃんママ" />
        <Button color='primary' onClick={() => removeMemberClicked()}>この人をフォルダの参加者から外す</Button>
      </MemberInformationDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MemberInformationDialog